import writingAvatars from '@images/home/writing-avatars.png'
import PhosphorIcon from 'teacher-ui-client/components/phosphor-icon'
import kidsGreen from '@images/home/kids-green.png'
import kidsBlue from '@images/home/kids-blue.png'
import Component from '@glimmer/component'
import { SubscriptionType } from 'teacher-ui-client/subscription-type/subscription-types'
import { HomeTile } from 'teacher-ui-client/components/home/tile'
import { themeKey } from 'teacher-ui-client/helpers/theme-key'
import { t } from 'ember-intl'
import { UiButtonLinkTo } from 'teacher-ui-client/components/ui-button/link-to'
import { UiButtonLink } from 'teacher-ui-client/components/ui-button/link'
import { ButtonAppearance } from 'teacher-ui-client/components/ui-button/themes'
import config from 'teacher-ui-client/config/environment'
import { join } from 'teacher-ui-client/utils/uri'
import type FeatureControlService from 'teacher-ui-client/services/feature-control'
import { service } from '@ember/service'

interface Args {
  subscriptionType: SubscriptionType
}

interface TileData {
  imageSrc: string
  imageAltKey: string
  descriptionKey: string
}

const tileData: Record<SubscriptionType, TileData> = {
  [SubscriptionType.Reading]: {
    imageSrc: kidsBlue,
    imageAltKey: 'pages.home.panels.manageStudents.stickFiguresAlt',
    descriptionKey: 'pages.home.panels.manageStudents.description',
  },
  [SubscriptionType.Maths]: {
    imageSrc: kidsGreen,
    imageAltKey: 'pages.home.panels.manageStudents.stickFiguresAlt',
    descriptionKey: 'pages.home.panels.manageStudents.description',
  },
  [SubscriptionType.Writing]: {
    imageSrc: writingAvatars,
    imageAltKey: 'pages.home.panels.manageStudents.writingAvatarsAlt',
    descriptionKey: 'pages.home.panels.manageStudents.descriptionNoCertificates',
  },
}

const oneRosterBaseUrl = join(config.oneRosterUrl, 'login')

export class ManageStudents extends Component<Args> {
  @service featureControl!: FeatureControlService

  get isOneRosterEnabled() {
    return this.featureControl.canAccess('one_roster')
  }

  get oneRosterManageStudentsUrl() {
    const studentsUrl = new URL(oneRosterBaseUrl)
    studentsUrl.searchParams.set('return_to', '/manage-students')

    return studentsUrl.toString()
  }

  get tileData() {
    return tileData[this.args.subscriptionType]
  }

  get imageSrc() {
    return this.tileData.imageSrc
  }

  <template>
    <HomeTile @themeKey={{themeKey @subscriptionType}} @title={{t "pages.home.panels.manageStudents.title"}}>
      <div class="space-y-3 bg-white p-3">
        <div class="flex h-28 items-start">
          <img class="mr-6" src={{this.imageSrc}} alt={{t this.tileData.imageAltKey}} />
          <p class="mb-3">{{t this.tileData.descriptionKey}}</p>
        </div>
        <div class="text-center">
          {{#if this.isOneRosterEnabled}}
            <UiButtonLink
              @appearance={{ButtonAppearance.regular}}
              href={{this.oneRosterManageStudentsUrl}}
              target="_blank"
              rel="noopener noreferrer"
            >
              {{t "pages.home.panels.manageStudents.rosterButtonLabel"}}
              <PhosphorIcon @icon="phosphor-arrow-square-out-bold" />
            </UiButtonLink>

          {{else}}
            <UiButtonLinkTo @route="manage.students" @appearance={{ButtonAppearance.regular}}>
              {{t "pages.home.panels.manageStudents.buttonLabel"}}
            </UiButtonLinkTo>
          {{/if}}
        </div>
      </div>
    </HomeTile>
  </template>
}

export default ManageStudents
